<template>
  <v-container grid-list-md>
    <v-data-table
      :headers="headers"
      :items="hosts.items"
      class="elevation-1"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.lastUpdateDate | date }}</td>
        <td>{{ props.item.address }}</td>
        <td class="text-xs-right">
          {{ props.item.numberOfRoom === -1 ? "?" : props.item.numberOfRoom }}
        </td>
        <td class="text-xs-right">{{ props.item.carrez }} m²</td>
        <td class="text-xs-right">{{ props.item.price }} €</td>
        <td class="text-xs-right">{{ props.item.isActive ? "Oui" : "Non" }}</td>
        <td class="text-xs-right">
          <router-link :to="`/host/${props.item._id}`">
            <v-btn flat>Voir le bien</v-btn>
          </router-link>
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  name: "HostsTable",
  props: ["hosts"],
  data: function() {
    return {
      headers: [
        {
          text: "Mise à jour",
          value: "lastUpdateDate"
        },
        {
          text: "Adresse",
          value: "address"
        },
        {
          text: "Pièces",
          value: "numberOfRoom",
          align: "right"
        },
        {
          text: "Surface",
          value: "carrez",
          align: "right"
        },
        {
          text: "Prix",
          value: "price",
          align: "right"
        },
        {
          text: "Disponible",
          value: "isActive",
          align: "right"
        },
        {
          text: "",
          sortable: false
        }
      ]
    };
  }
};
</script>

<style scoped></style>
